<template>
    <div class="">
        <section class="breadcrumb-section mt_20">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Manage Payment
                        </li>
                    </ol>
                </nav>
            </div>
        </section>

        <section class="myorder_section pt-0 pb-0 manage_payment">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="dashboard_design d-md-flex mb_82">
                            <div class="side_bar px-0 sidebar_desk">
                                <ul class="side_bar_links mt_2 p-0">
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/myorder.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Orders</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/saved_design.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Saved Designs</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/upload_img.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Uploaded Images</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/payement.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Payment Options</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/fav.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Favorite</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/edit_profile.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Edit Profile</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class="active"
                                            ><img
                                                src="/maincss/images/mystore.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />My Store</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_payment.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Player</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/manage_team.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Manage Team</a
                                        >
                                    </li>
                                    <li>
                                        <a href="#" class=""
                                            ><img
                                                src="/maincss/images/logout.svg"
                                                alt=" "
                                                class="side_bar_icon"
                                            />Logout</a
                                        >
                                    </li>
                                </ul>
                            </div>
                            <div class="sidebar_mobile">
                                <a class="dropdown-toggle" id="item2" href="#"
                                    >My Account</a
                                >
                                <div class="side_bar px-0">
                                    <ul
                                        id="submenu2"
                                        class="side_bar_links mt_2 p-0 dropdown"
                                    >
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/myorder.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Orders</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/saved_design.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Saved Designs</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/upload_img.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Uploaded Images</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/payement.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Payment Options</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/fav.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Favorite</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/edit_profile.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Edit Profile</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class="active"
                                                ><img
                                                    src="/maincss/images/mystore.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />My Store</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_payment.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Player</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/manage_team.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Manage Team</a
                                            >
                                        </li>
                                        <li>
                                            <a href="#" class=""
                                                ><img
                                                    src="/maincss/images/logout.svg"
                                                    alt=" "
                                                    class="side_bar_icon"
                                                />Logout</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="left_panel store_details_wrap">
                                <div
                                    class="panel_head_wrap d-flex justify-content-between"
                                >
                                    <div class="panel_heading">
                                        <h2
                                            class="font_size_20 font-weight-bold"
                                        >
                                            Store - Carlsbad High School
                                            Lacrosse
                                        </h2>
                                        <div
                                            class="store_detail_subhead d-flex justify-content-between mt_30"
                                        >
                                            <div class="store_type">
                                                <h4
                                                    class="font_size_18 text-uppercase"
                                                >
                                                    Store Details
                                                </h4>
                                                <p
                                                    class="font_size_16 text_black font-weight-bold"
                                                >
                                                    La Crosse
                                                </p>
                                            </div>
                                            <div class="order_handeling">
                                                <h4 class="font_size_18">
                                                    Order Handling Fee
                                                </h4>
                                                <p
                                                    class="font_size_16 text_black font-weight-bold"
                                                >
                                                    $2.65
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="select_checkbox form-check pl_8 py_6 pt_30"
                                    >
                                        <label
                                            class="checkbox_custom font_size_20"
                                            >Select All
                                            <input type="checkbox" />
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>

                                <div class="store_detail_box mt_40">
                                    <div class="row mt_30">
                                        <div class="col-md-6 col-xl-4">
                                            <div class="product mb_110">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex store_detail_btn"
                                                    >
                                                        <a
                                                            href="#"
                                                            class="text_primary_blue border_primary_blue border font_size_15 mr_6 py_18 text-center text-uppercase remove_btn"
                                                            >REMOVE</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="place_order bg_primary_orange font_size_15 py_18 text-center text-uppercase ml_6 text_white heading5 d-flex justify-content-center align-items-center"
                                                        >
                                                            DESIGN</a
                                                        >
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6 d-flex justify-content-center align-items-center"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_20"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_20"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xl-4">
                                            <div class="product mb_110">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_primary_red font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex store_detail_btn"
                                                    >
                                                        <a
                                                            href="#"
                                                            class="text_primary_blue border_primary_blue border font_size_15 mr_6 py_18 text-center text-uppercase remove_btn"
                                                            >REMOVE</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="place_order bg_primary_orange font_size_15 py_18 text-center text-uppercase ml_6 text_white heading5 d-flex justify-content-center align-items-center"
                                                        >
                                                            DESIGN</a
                                                        >
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_20"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_20"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xl-4">
                                            <div class="product mb_110">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex store_detail_btn"
                                                    >
                                                        <a
                                                            href="#"
                                                            class="text_primary_blue border_primary_blue border font_size_15 mr_6 py_18 text-center text-uppercase remove_btn"
                                                            >REMOVE</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="place_order bg_primary_orange font_size_15 py_18 text-center text-uppercase ml_6 text_white heading5 d-flex justify-content-center align-items-center"
                                                        >
                                                            DESIGN</a
                                                        >
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_20"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_20"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xl-4">
                                            <div class="product pb_58">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex store_detail_btn"
                                                    >
                                                        <a
                                                            href="#"
                                                            class="text_primary_blue border_primary_blue border font_size_15 mr_6 py_18 text-center text-uppercase remove_btn"
                                                            >REMOVE</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="place_order bg_primary_orange font_size_15 py_18 text-center text-uppercase ml_6 text_white heading5 d-flex justify-content-center align-items-center"
                                                        >
                                                            DESIGN</a
                                                        >
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_20"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_20"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xl-4">
                                            <div class="product pb_58">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex store_detail_btn"
                                                    >
                                                        <a
                                                            href="#"
                                                            class="text_primary_blue border_primary_blue border font_size_15 mr_6 py_18 text-center text-uppercase remove_btn"
                                                            >REMOVE</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="place_order bg_primary_orange font_size_15 py_18 text-center text-uppercase ml_6 text_white heading5 d-flex justify-content-center align-items-center"
                                                        >
                                                            DESIGN</a
                                                        >
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_20"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_20"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xl-4">
                                            <div class="product pb_58">
                                                <div
                                                    class="product_image d-flex justify-content-center bg_primary_light_white py_30 position-relative"
                                                >
                                                    <img
                                                        src="/maincss/images/product_2.png"
                                                        alt=" "
                                                        class="img-fluid product_image_main"
                                                    />
                                                    <span
                                                        class="offer-badge px_20 py_2 bg_secondary_black font_size_16 text_white"
                                                        >-86%</span
                                                    >

                                                    <div
                                                        class="hover_buttons d-inline-flex store_detail_btn"
                                                    >
                                                        <a
                                                            href="#"
                                                            class="text_primary_blue border_primary_blue border font_size_15 mr_6 py_18 text-center text-uppercase remove_btn"
                                                            >REMOVE</a
                                                        >
                                                        <a
                                                            href="#"
                                                            class="place_order bg_primary_orange font_size_15 py_18 text-center text-uppercase ml_6 text_white heading5 d-flex justify-content-center align-items-center"
                                                        >
                                                            DESIGN</a
                                                        >
                                                    </div>

                                                    <div
                                                        class="form-check pl-0 py_6"
                                                    >
                                                        <label
                                                            class="checkbox_custom"
                                                        >
                                                            <input
                                                                type="checkbox" /><span
                                                                class="checkmark"
                                                            ></span
                                                        ></label>
                                                    </div>
                                                </div>
                                                <div
                                                    class="product_content mt_22"
                                                >
                                                    <h5
                                                        class="heading5 font_size_20"
                                                    >
                                                        2 Mesh Long Sleeve Tee
                                                    </h5>

                                                    <div
                                                        class="d-flex justify-content-center align-items-center"
                                                    >
                                                        <h6
                                                            class="heading6 mb-0 font_size_20"
                                                        >
                                                            <span
                                                                class="text_primary_red mr_18"
                                                                >$2.00</span
                                                            >
                                                            <span
                                                                class="text_light_grey"
                                                                >$3.00</span
                                                            >
                                                        </h6>
                                                        <div class="ml-auto">
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_blue"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_yellow"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_primary_orange"
                                                            ></a>
                                                            <a
                                                                href="#"
                                                                class="color_circle mr_6 bg_secondary_black"
                                                            ></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {
    name: "StoreDetails",
    components: {},
    mounted() {
        // document.body.classList.add('bg_primary_light_white');
        /* eslint-disable */
        $(function () {
            $("#item2").click(function () {
                $("#submenu2").slideToggle(500);
            });
        });
        /* eslint-enable */
    }
};
</script>
